import React, {useEffect, useState} from "react";
import {Field, Panel} from "../../../../layouts";
import ValidationGroup from "devextreme-react/validation-group";
import {TextBox} from "devextreme-react/text-box";
import Validator, {EmailRule, RequiredRule, StringLengthRule} from "devextreme-react/validator";
import {CUSTOMER_ADDRESS_MAX_LENGTH} from "../../customer-address-validation";
import {useEEToolContext} from "../contexts/eeToolContext";
import {useZipCodeInformation} from "../api/get-zip";

export function CustomerInformationControl() {
    const context = useEEToolContext();
    const zipInfo = useZipCodeInformation(context.customerZip);

    useEffect(() => {
        if (!zipInfo.data) {
            return;
        }

        context.setCustomerState(zipInfo.data.state);
        context.setCustomerCity(zipInfo.data.city);
        context.setCustomerCountry(zipInfo.data.country);
    }, [zipInfo.data])

    return (
        <Panel
            header={'Customer Information'}
        >
            <ValidationGroup>
                <Field label={'Name'}>
                    <TextBox inputAttr={{'data-testid': 'txt-estimate-user-name'}}
                             className='required'
                             value={context.customerName}
                             onValueChanged={(e) => context.setCustomerName(e.value)}
                    >
                        <Validator validationGroup='newEstimateValidationGroup'>
                            <RequiredRule message={'Customer Name is required'}></RequiredRule>
                        </Validator>
                    </TextBox>
                </Field>
                <Field label={'Address 1'}>
                    <TextBox inputAttr={{'data-testid': 'txt-estimate-address1'}}
                             className='required'
                             maxLength={CUSTOMER_ADDRESS_MAX_LENGTH}
                             value={context.customerAddress1}
                             onValueChanged={(e) => context.setCustomerAddress1(e.value)}
                    >
                        <Validator validationGroup='newEstimateValidationGroup'>
                            <RequiredRule message={'Customer Address1 is required'}></RequiredRule>
                            <StringLengthRule max={CUSTOMER_ADDRESS_MAX_LENGTH}
                                message={`Customer address line 1 is too long (max ${CUSTOMER_ADDRESS_MAX_LENGTH} characters).`} />
                        </Validator>
                    </TextBox>
                </Field>
                <Field label={'Address 2'}>
                    <TextBox inputAttr={{'data-testid': 'txt-estimate-address2'}}
                             maxLength={CUSTOMER_ADDRESS_MAX_LENGTH}
                             value={context.customerAddress2}
                             onValueChanged={(e) => context.setCustomerAddress2(e.value)}
                    >
                        <Validator validationGroup='newEstimateValidationGroup'>
                            <StringLengthRule max={CUSTOMER_ADDRESS_MAX_LENGTH}
                                message={`Customer address line 2 is too long (max ${CUSTOMER_ADDRESS_MAX_LENGTH} characters).`} />
                        </Validator>
                    </TextBox>
                </Field>
                <Field label={'Zip'}>
                    <TextBox inputAttr={{'data-testid': 'txt-estimate-zip'}}
                             className='required'
                             value={context.customerZip}
                             maxLength={5}
                             onValueChanged={(e) => context.setCustomerZip(e.value)}
                    >
                        <Validator validationGroup='newEstimateValidationGroup'>
                            <RequiredRule message={'Customer Zip is required'}></RequiredRule>
                        </Validator>
                    </TextBox>
                </Field>
                <Field label={'City'}>
                    <TextBox inputAttr={{'data-testid': 'txt-estimate-city'}}
                             className='required'
                             disabled={zipInfo.isLoading}
                             value={context.customerCity}
                             onValueChanged={(e) => context.setCustomerCity(e.value)}
                    >
                        <Validator validationGroup='newEstimateValidationGroup'>
                            <RequiredRule message={'Customer City is required'}></RequiredRule>
                        </Validator>
                    </TextBox>
                </Field>
                <Field label={'State'}>
                    <TextBox inputAttr={{'data-testid': 'txt-estimate-state'}}
                             className='required'
                             disabled={zipInfo.isLoading}
                             value={context.customerState}
                             onValueChanged={(e) => context.setCustomerState(e.value)}
                    >
                        <Validator validationGroup='newEstimateValidationGroup'>
                            <RequiredRule message={'Customer State is required'}></RequiredRule>
                        </Validator>
                    </TextBox>
                </Field>
                <Field label={'Country'}>
                    <TextBox inputAttr={{'data-testid': 'txt-estimate-country'}}
                             className='required'
                             disabled={zipInfo.isLoading}
                             value={context.customerCountry}
                             onValueChanged={(e) => context.setCustomerCountry(e.value)}
                    >
                        <Validator validationGroup='newEstimateValidationGroup'>
                            <RequiredRule message={'Customer Country is required'}></RequiredRule>
                        </Validator>
                    </TextBox>
                </Field>
                <Field label={'Phone'}>
                    <TextBox inputAttr={{'data-testid': 'txt-estimate-phone'}}
                             className='required'
                             mask="000-000-0000"
                             maskChar=""
                             value={context.customerPhone}
                             onValueChanged={(e) => context.setCustomerPhone(e.value)}
                    >
                        <Validator validationGroup='newEstimateValidationGroup'>
                            <RequiredRule message={'Customer Phone is required'}></RequiredRule>
                        </Validator>
                    </TextBox>
                </Field>
                <Field label={'Email'}>
                    <TextBox inputAttr={{'data-testid': 'txt-estimate-email'}}
                             className='required'
                             value={context.customerEmail}
                             onValueChanged={(e) => context.setCustomerEmail(e.value)}
                    >
                        <Validator validationGroup='newEstimateValidationGroup'>
                            <RequiredRule message={'Customer Email is required'}></RequiredRule>
                            <EmailRule
                                message="Email is invalid"/>
                        </Validator>
                    </TextBox>
                </Field>
            </ValidationGroup>
        </Panel>)
}